import { create } from 'zustand';
import { persist } from 'zustand/middleware';

interface Company {
  id: string;
  name: string;
  short_name?: string;
  tax_number?: string;
  vat_number?: string;
}

interface AuthState {
  token: string | null;
  userId: string | null;
  tenantId: string | null;
  role: string | null;
  theme: 'light' | 'dark';
  selectedCompany: Company | null;
  setAuth: (token: string, userId: string, tenantId: string, role: string) => void;
  logout: () => void;
  toggleTheme: () => void;
  setSelectedCompany: (company: Company | null) => void;
}

export const useAuthStore = create<AuthState>()(
  persist(
    (set, get) => ({
      token: null,
      userId: null,
      tenantId: null,
      role: null,
      theme: 'light',
      selectedCompany: null,
      setAuth: (token, userId, tenantId, role) => {
        localStorage.setItem('token', token);
        set({ token, userId, tenantId, role });
      },
      logout: () => {
        localStorage.removeItem('token');
        set({ token: null, userId: null, tenantId: null, role: null, selectedCompany: null });
      },
      toggleTheme: () => {
        const newTheme = get().theme === 'light' ? 'dark' : 'light';
        set({ theme: newTheme });
        if (newTheme === 'dark') {
          document.documentElement.classList.add('dark');
        } else {
          document.documentElement.classList.remove('dark');
        }
      },
      setSelectedCompany: (company) => set({ selectedCompany: company }),
    }),
    { name: 'aicount-auth' }
  )
);
